<template>
    <div class="co-nome-signatario">
        <v-text-field
            v-model="value.nome"
            v-validate="validarCampo()"
            :class="campoRequerido ? 'required-field' : ''"
            :error-messages="coletarErros(errors)"
            :label="label"
            :name="label"
            :placeholder="placeholder"
            persistent-placeholder
            @input="toTitleCase"
        />

        <div v-if="descricao" class="hint-checkbox">
            {{ descricaoCampo }}
        </div>
    </div>

</template>

<script>
export default {
    name: 'NomeSignatario',
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        descricao: {
            type: Boolean
        },
        titleCase: {
            type: Boolean,
            default: false
        },
        formScope: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        descricaoCampo() {
            return `Aqui você pode definir um nome o qual ${this.$tc("pt_br.signatario").toLowerCase()} deseja ser chamado.`
        },
        label() {
            return `Nome do ${this.$tc("pt_br.signatario").toLowerCase()}`
        },
        placeholder() {
            return `Informe o nome do ${this.$tc("pt_br.signatario").toLowerCase()}`
        }
    },
    methods: {
        coletarErros(e) {
            if (this.formScope !== null) {
                return e.collect(this.label, this.formScope)
            }

            return e.collect(this.label)
        },
        validarCampo() {
            return this.campoRequerido ? 'required' : ''
        },
        toTitleCase() {
            if (this.titleCase) {
                this.value.nome = this.value.nome.replace(/(^|\s)\S/g, function (t) {
                    return t.toUpperCase()
                });
            }
        }
    }
}
</script>
